import { getEnvironmentFromHost } from './getEnvironmentFromHost';

/*
 * Retrieves app environment.
 */
export const getEnvironment = getEnvironmentFromHost;
